export default {};

export const reducerNames = {
  loaded: 'loaded',
  staging: 'staging',
  ui: 'ui',
};
